import bcrypt from 'bcryptjs';

const saltRounds = 10; // Adjust based on security requirements

export const parseDOB = (dob: string) => {
  const password = dob.replace(/[-\/]/g, '');
  return password;
};

export const hashPassword = async (password: string): Promise<string> => {
  try {
    const hashedPassword = await bcrypt.hash(password, saltRounds);
    return hashedPassword;
  } catch (error) {
    console.error('Error hashing password:', error);
    return '';
  }
};

export const comparePassword = async (
  plainPassword: string,
  hashedPassword: string,
) => {
  try {
    return await bcrypt.compare(plainPassword, hashedPassword);
  } catch (error) {
    console.error('Error comparing password:', error);
    return false;
  }
};
